
class Auth {
  constructor() {
 
    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  getProfile() {
    return this.profile;
  }

  getIdToken() {
    return this.idToken;
  }

  isAuthenticated() {
    return new Date().getTime() < this.expiresAt;
  }


  handleAuthentication() {
    
  }

  setSession(authResult) {
    this.token = authResult.data.token;
    this.refresh_token = authResult.data.refresh_token;
    // set the time that the id token will expire at
    this.expiresAt = new Date().getTime() + 3600 * 1000 ;
  }


  signOut() {
    this.token = '';
    this.refresh_token = '';
    // set the time that the id token will expire at
    this.expiresAt = '' ;
  }

  silentAuth() {
    return this.refresh_token;    
  }
}

const authClient = new Auth();

export default authClient;